import React, { useEffect, useState } from "react";

interface LeasedEquipmentModalDetailsProps {
  leDetails: any;
  isOffice: boolean;
}

const LeasedEquipmentModalDetails: React.FC<
  LeasedEquipmentModalDetailsProps
> = ({ leDetails, isOffice }) => {
  const [firstCol, setFirstCol] = useState<
    Record<string, [string, React.ReactNode]>
  >({});
  const [secondCol, setSecondCol] = useState<
    Record<string, [string, React.ReactNode]>
  >({});

  useEffect(() => {
    if (!leDetails) return;

    if (isOffice) {
      setFirstCol({
        officeCode: ["Office Code", leDetails.officeCode],
        officeName: ["Office Name", leDetails.officeName],
        officeNumber: ["Office Number", leDetails.officeNumber],
        address: ["Address", leDetails.address],
        city: ["City", leDetails.city],
        state: ["State", leDetails.state],
        zip: ["Zip", leDetails.zip],
        type: ["Type", leDetails.type],
        make: ["Make", leDetails.make],
      });

      setSecondCol({
        // type: ["Type", agmtDetails.type],
        // make: ["Make", agmtDetails.make],
        model: ["Model", leDetails.model],
        supplyAlertProfile: [
          "Supply Alert Profile",
          leDetails.supplyAlertProfile,
        ],

        serialNumber: ["Serial Number", leDetails.serialNumber],
        customerNumber: ["Customer Number", leDetails.customerNumber],
        vendorLocationNumber: [
          "Vendor Location Number",
          leDetails.vendorLocationNumber,
        ],
        purchasingVendorNumber: [
          "Purchasing Vendor",
          leDetails.purchasingVendorNumber || "",
        ],
        status: ["Status", leDetails.status],
        servicingDealer: ["Servicing Dealer", leDetails.servicingDealer],
      });
    } else {
      setFirstCol({
        vendorStorage: ["Vendor Storage", leDetails.vendorStorage],
        type: ["Type", leDetails.type],
        make: ["Make", leDetails.make],
        model: ["Model", leDetails.model],
        supplyAlertProfile: [
          "Supply Alert Profile",
          leDetails.supplyAlertProfile,
        ],
        serialNumber: ["Serial Number", leDetails.serialNumber],
      });

      setSecondCol({
        customerNumber: ["Customer Number", leDetails.customerNumber],
        vendorLocationNumber: [
          "Vendor Location Number",
          leDetails.vendorLocationNumber,
        ],
        purchasingVendorNumber: [
          "Purchasing Vendor",
          leDetails.purchasingVendorNumber || "",
        ],
        status: ["Status", leDetails.status],
        servicingDealer: ["Servicing Dealer", leDetails.servicingDealer],
      });
    }
  }, [leDetails]);

  if (!leDetails) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-xs px-8 py-4">
      <div className="space-y-2">
        {Object.entries(firstCol).map(([key, [label, value]]) => (
          <div key={key} className="w-full border-b border-gray-200 py-1">
            <div className="grid grid-cols-2">
              <label className="expandedLabel fontExpand text-left ml-2">
                <span>{label}: </span>
              </label>
              <span className="expandedData fontExpand">{value}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="space-y-2">
        {Object.entries(secondCol).map(([key, [label, value]]) => (
          <div key={key} className="w-full border-b border-gray-200 py-1">
            <div className="grid grid-cols-2">
              <label className="expandedLabel fontExpand text-left ml-2">
                <span>{label}: </span>
              </label>
              <span className="expandedData fontExpand font-semibold">
                {value}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeasedEquipmentModalDetails;
